module.exports = __webpack_public_path__ + "static/media/Santa Rosa Avenue, Santa Barbara, CA6.db5e5a93.jpg";